import React from 'react';
import { VStack } from '@televet/kibble-ui/build/chakra';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { Spinner } from '@televet/kibble-ui/build/components/Spinner';

interface ILoadingSpinnerProps {
  loadingText: string;
}

const LoadingSpinner = ({ loadingText }: ILoadingSpinnerProps): JSX.Element => (
  <VStack p={30} px={5} spacing={0}>
    <Text size="xl" fontWeight="bold">
      {loadingText}
    </Text>
    <Spinner />
  </VStack>
);

export default LoadingSpinner;
